import { render } from "./Fase6Page.vue?vue&type=template&id=efd02b20&scoped=true"
const script = {}

import "./Fase6Page.vue?vue&type=style&index=0&id=efd02b20&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-efd02b20"]])

export default __exports__